import { FC } from 'react';
import { IRouteGroup } from '../../../types';
import SidebarItem from './item';

const SidebarGroup: FC<IRouteGroup> = (props) => {

  const {
    group,
    routes,
  } = props;

  const RouteList = routes.map((route, i) => <SidebarItem key={i} {...route} />);

  // don't show a group name for undefined ones
  if (group === 'undefined')
    return (
      <ul>
        {RouteList}
      </ul>
    );

  return (
    <>
      <p className="menu-label">
        {group}
      </p>

      <ul>
        {RouteList}
      </ul>
    </>
  );

};

export default SidebarGroup;
